import { BASE_URL, CLIENT_KEY, CLIENT_SECRET } from '../env'
import TokenServices from '../services/tokenServices'

const getCredentials = () => {}

export const baseUrl = BASE_URL
export const apiCredentials = new Buffer(
  `${CLIENT_KEY}:${CLIENT_SECRET}`
).toString('base64')

export function getTokenHeaders(extraStuff = {}) {
  const headers = {
    'Accept-Language': 'es-AR',
    'Content-Type': 'application/json; charset=utf-8',
    Authorization: `Bearer ${TokenServices.getAccessToken()}`
  }
  return Object.assign({}, headers, extraStuff)
}

export function getCredentialHeaders() {
  return {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;  charset=utf-8',
      Authorization: `Basic ${apiCredentials}`
    }
  }
}
// Queda pendiente tratar de unir estas funciones haciendo dinamico el content-type

export function getCredentialHeadersJson() {
  return {
    headers: {
      'Content-Type': 'application/json;  charset=utf-8',
      Authorization: `Basic ${apiCredentials}`
    }
  }
}

export default {
  baseUrl,
  getTokenHeaders,
  getCredentialHeaders,
  getCredentialHeadersJson,
  apiCredentials
}
